import { Spinner, useToast } from '@chakra-ui/react'
import { useMyScholarship } from '@olagg/api-hooks'
import { GameCredentials } from '@olagg/db-types'
import { FC, useState } from 'react'
import MultiStageModal from '../../components/MultiStageModal'
import { ConfirmInfo } from './components/ConfirmInfo'
import { RequestInfo } from './components/RequestInfo'
import { Success } from './components/Success'
import { checkIfValid } from './utils'

interface IProps {
  isOpen: boolean
  onClose: () => void
  credentials: GameCredentials
  applicationId?: number
  fieldsToComplete: string[]
}

export interface ICompletedFields {
  username: string
  email: string
  password: string
  walletAddress: string
  seedPhrase: string
  userNotes: string
  nftIdentifier: string
}

const CompleteGameCredentials: FC<IProps> = ({
  isOpen,
  onClose,
  credentials,
  applicationId,
  fieldsToComplete
}) => {
  const toast = useToast()

  const { scholarship, getScholarship } = useMyScholarship()

  const [currentStep, setCurrentStep] = useState<
    'requestInfo' | 'confirmInfo' | 'success'
  >('requestInfo')

  const [completedFields, setCompletedFields] =
    useState<ICompletedFields>({
      username: '',
      email: '',
      password: '',
      walletAddress: '',
      seedPhrase: '',
      userNotes: '',
      nftIdentifier: ''
    })

  const onClickContinue = () => {
    const isValueMissing = checkIfValid({
      fieldsToComplete,
      completedFields
    })
    if (!isValueMissing) setCurrentStep('confirmInfo')
    else {
      toast({
        title: 'Error',
        colorScheme: 'olaggYellow',
        status: 'error',
        description: 'Por favor rellena todos los campos',
        position: 'bottom-right',
        duration: 3000,
        isClosable: true
      })
    }
  }

  const clickClose = () => {
    getScholarship(credentials.gameId)
    onClose()
    setCurrentStep('requestInfo')
    Object.entries(completedFields).forEach(([key]) => {
      setCompletedFields(prev => ({ ...prev, [key]: '' }))
    })
  }

  return (
    <MultiStageModal
      currentStep={currentStep}
      isOpen={isOpen}
      onClose={clickClose}
      scrollBehaviour="outside"
      content={{
        loading: {
          body: <Spinner />,
          footer: <></>
        },
        requestInfo: RequestInfo({
          credentials,
          fieldsToComplete,
          completedFields,
          setCompletedFields,
          onClickContinue
        }),
        confirmInfo: ConfirmInfo({
          completedFields,
          credentials,
          setCurrentStep
        }),
        success: Success({
          onClose: clickClose,
          currentStep,
          gameId: credentials.gameId,
          applicationId: applicationId || scholarship?.id,
          credentialsId: credentials.id,
          inputs: completedFields
        })
      }}
    />
  )
}

export default CompleteGameCredentials
